const BaseView = require('../../components/accordion-list/categories-director');

module.exports = BaseView.extend({
  selectedCategory: 'all',
  views: {},
  template: require('./stock-template.hbs'),

  events: _.extend({
    'click .search-close': 'closeSearchEvent',
    'click .categories-container .category-list .category-element': 'selectCategoryEvent',
    'click .categories-container .category-title': 'toggleCategoryDropdownEvent',
    'click .categories-container .category-title + icon': 'toggleCategoryDropdownEvent'
  }, BaseView.prototype.events),

  toggleCategoryDropdownEvent: function () {
    const $categoryList = this.$el.find('.category-list');

    $categoryList.toggleClass('hidden');
    $categoryList.antiscroll({ autoHide: false });

    function hideCategoryList (event) {
      if (!$(event.target).parents('.categories-container').length) {
        $categoryList.addClass('hidden');
        $(document).off('mouseup', hideCategoryList);
      }
    }

    $categoryList.is('.hidden') || $(document).on('mouseup', hideCategoryList);
  },

  searchClickEvent: function (event) {
    this.isHidden = false;
    this.$searchOptions && this.$searchOptions[$(event.target).is('input') ? 'hide' : 'toggle']();
  },

  selectCategoryEvent: function (event) {
    const $element = $(event.currentTarget);
    const $categoryList = $element.closest('.category-list');

    $categoryList.addClass('hidden');
    $categoryList.find('.category-element').removeClass('selected');

    $element.toggleClass('selected');

    this.$el.find('.category-title').html($element.html());
    $element.addClass('selected');
    this.loadListContent($element.data('key'));
  },

  closeSearchEvent: function (event) {
    const $searchTitle = $(event.currentTarget).parents('.search-title');
    const $categoriesContainer = $searchTitle.siblings('.categories-container');
    const allTitle = $categoriesContainer.find('.category-element:first-child').html();
    const searchInput = this.$el.closest('.tab-content').find('.search-container input');

    $searchTitle.addClass('hidden');
    this.$searchOptions && this.$searchOptions.hide();
    $categoriesContainer.removeClass('hidden');
    $categoriesContainer.find('.category-title').html(allTitle);
    searchInput.val('');
    searchInput.toggleClass('searching');

    this.$el.find('.thumbnail-wrapper').empty().css('height', '');

    this.hasDefaults && this.loadListContent('all');
  },

  initialize: function (options) {
    _.bindAll(this, 'refreshAntiscroll');

    this.tool = INKIVE.Tool.getInstance();
    this.hasDefaults = !options.simplified;

    BaseView.prototype.initialize.call(this);
    this.render();
  },

  _render: function (categories) {
    INKIVE.Modal.loaderClose(this.$el);

    INKIVE.EditorFacade.once('imageTab.stock.images.loaded', () => {
      this.el.querySelector('.image-shimmers').remove();
    });

    this.$el.html(this.template({
      categories: this.hasDefaults && categories,
      shimmersRange: Array.from({ length: 5 })
    }));

    if (this.hasDefaults) {
      this.loadListContent('all');
      this.initCategoryGroup();
    }

    this.focusSearchInput();
  },

  focusSearchInput: function () {
    document.querySelector('.tab.active .search-container > input[name=search]')?.focus();
  },

  loadListContent: function (key) {
    this.selectedCategory = this.cid + key;

    this.views[this.cid + key] = new this.CategoriesView({
      el: this.$el.find('.image-list'),
      key
    });

    return this.views[this.cid + key];
  },

  initCategoryGroup: function () {
    const $categoryList = this.$el.find('.category-list');

    this.tool.initScroll($categoryList);
    $categoryList.addClass('hidden');
  },

  refreshAntiscroll: function () {
    this.$el.find('.antiscroll-inner').width('');
    this.$el.find('.antiscroll-wrap').antiscroll({ horizontal: false });
  },

  refresh: function () {
    this.refreshAntiscroll();

    _.each(this.views, function (view) {
      view.masonryReload();

      checkForMoreContent();
      _.delay(checkForMoreContent, 2000);

      function checkForMoreContent () {
        view.$el.find('.antiscroll-inner').trigger('scroll');
      }
    });

    this.focusSearchInput();
  },

  getRandomSearchValue: function () {
    const defaultSearch = ['landscape', 'autumn OR spring', 'summer holidays'];
    const index = Math.floor(Math.random() * defaultSearch.length);
    return defaultSearch[index];
  }
});
